import { AfterViewInit, ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import Keyboard from 'simple-keyboard';
import SimpleKeyboard from 'simple-keyboard';
import { PuzzleKeyboardService } from './puzzle-keyboard.service';
import { Store } from '@ngxs/store';
import { addIcons } from 'ionicons';
import { backspaceSharp, refreshSharp } from 'ionicons/icons';

@Component({
  selector: 'lib-puzzle-softkeyboard',
  templateUrl: './puzzle-softkeyboard.component.html',
  styleUrls: ['./puzzle-softkeyboard.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PuzzleSoftkeyboardComponent implements AfterViewInit {
  private keyboard: SimpleKeyboard;
  showKeyboard = false;

  constructor(private service: PuzzleKeyboardService, private cd: ChangeDetectorRef, private store: Store) {
    // this.store.select(store => store.puzzleGameState.keepKeyboardOpen).subscribe(keepOpen => {
    //   if (keepOpen) {
    //     this.service.openSoftKeyboard();
    //   }
    // });
    addIcons({ backspaceSharp, refreshSharp });
  }

  private emitKey(key: string) {
    this.service.softKeyboardEmit(key);
  }

  private onChange(input: any) {}

  private onKeyPress(button: any) {
    switch (button) {
      case '{bksp}':
        this.emitKey('');
        break;
      case '{rot}':
        this.emitKey(' ');
        break;
      default:
        this.emitKey(button);
        break;
    }
  }

  ngAfterViewInit(): void {
    this.keyboard = new Keyboard({
      onChange: (input) => this.onChange(input),
      onKeyPress: (button) => this.onKeyPress(button),
      theme: 'hg-theme-default krupion-softkeyboard',
      layout: {
        default: ['Q W E R T Z U I O P', '{1_2} A S D F G H J K L {1_2}', '{rot} {1_4} Y X C V B N M {1_4} {bksp}'],
      },
      display: {
        '{1_2}': ' ',
        '{1_4}': ' ',
        '{bksp}': '<ion-icon name="backspace-sharp"></ion-icon>',
        '{rot}': '<ion-icon name="refresh-sharp"></ion-icon>',
      },
    });

    this.service.softKeyboardOpen$.subscribe(async (open) => {
      this.showKeyboard = open;
      this.cd.detectChanges();
    });

    // console.log(this.headerElementRef, this.footerElementRef);
  }

  @HostListener('document:click')
  clickedOutside() {
    this.service.closeSoftKeyboard();
  }

  clickedInside($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
  }
}
